import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar/Navbar'
import Hero from '../../components/hero/hero';
import About from '../../components/about/about';
import CausesSecion from '../../components/CausesSecion/CausesSecion';
import FunFact from '../../components/FunFact/FunFact';
import TeamSection from '../../components/TeamSection/TeamSection';
import EventSection from '../../components/EventSection/EventSection';
import TestimonialSection from '../../components/TestimonialSection/TestimonialSection';
import BlogSection from '../../components/BlogSection/BlogSection';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
// import Logo from '../../images/cbverse.svg';
import Logo from "../../images/caobangceritage.svg"
import ServiceSection from '../../components/ServiceSection/ServiceSection';
import Hero4 from '../../components/Hero4/Hero4';
import BlogSectionS2 from '../../components/BlogSectionS2/BlogSectionS2';
import BotChatGPT from '../ChatbotPopUp';
import AiVoice from '../../components/AiVoice/AiVoice';
const HomePage = () => {
    return (
        <Fragment>
            <Navbar Logo={Logo} hclass="wpo-site-header-s3" />
            <Hero4 />
            <ServiceSection />
            <About />
            {/* <TeamSection /> */}
            <BlogSectionS2 />
            <Footer />
            <AiVoice />
            <BotChatGPT />

        </Fragment>
    )
};
export default HomePage;